import 'catalog/components/Catalog/Catalog.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';
import { ConfigsContainer, ConfigsModel } from '@sm360/widget-commons-configs';

import * as Actions from 'catalog/actions/catalogActions.js';
import CatalogFilterModel from 'catalog/models/CatalogFilterModel.js';
import ManufacturerModel from 'catalog/models/ManufacturerModel.js';

import CatalogHeader from 'catalog/components/CatalogHeader/CatalogHeader.jsx';
import CatalogFilter from 'catalog/components/CatalogFilter/CatalogFilter.jsx';
import CatalogList from 'catalog/components/CatalogList/CatalogList.jsx';
import CatalogFooter from 'catalog/components/CatalogFooter/CatalogFooter.jsx';

const Catalog = ({
    configs,
    catalogFilter,
    actions,
    manufacturer,
    buildAndQuoteUrl,
    isLoading,
    purchaseMethods,
    hasAdobeTagging,
    displayCreditRate,
    isCustomBodyStyle,
    noMakeListStr,
    modelListStr,
}) => {
    const bgImage = ContentZonesService.getContentZone('widget.catalog', 'background.img');
    const styleBackground = {
        backgroundImage: `url(${
            bgImage && bgImage.getValue()
                ? bgImage.getValue()
                : `${configs.source.image}/images/widget/showroom/asset/catalog-background.jpg`
        })`,
    };
    return (
        <div className="catalog" style={styleBackground}>
            <CatalogHeader />
            <CatalogFilter
                catalogFilter={catalogFilter}
                selectPurchaseMethod={actions.selectPurchaseMethod}
                selectPaymentFrequency={actions.selectPaymentFrequency}
                resetBodyStylesFilter={actions.resetBodyStylesFilter}
                filterMake={actions.filterMake}
                filterModel={actions.filterModel}
                hasAdobeTagging={hasAdobeTagging}
                isCustomBodyStyle={isCustomBodyStyle}
            />
            <CatalogList
                catalogFilter={catalogFilter}
                manufacturer={manufacturer}
                buildAndQuoteUrl={buildAndQuoteUrl}
                isLoading={isLoading}
                displayCreditRate={displayCreditRate}
                noMakeListStr={noMakeListStr}
                modelListStr={modelListStr}
            />
            <CatalogFooter purchaseMethods={purchaseMethods} />
        </div>
    );
};

Catalog.defaultProps = {
    displayCreditRate: false,
    isCustomBodyStyle: false,
};
Catalog.propTypes = {
    catalogFilter: PropTypes.instanceOf(CatalogFilterModel).isRequired,
    manufacturer: PropTypes.instanceOf(ManufacturerModel).isRequired,
    actions: PropTypes.shape({
        selectPurchaseMethod: PropTypes.func.isRequired,
        selectPaymentFrequency: PropTypes.func.isRequired,
        resetBodyStylesFilter: PropTypes.func.isRequired,
        filterMake: PropTypes.func.isRequired,
        filterModel: PropTypes.func.isRequired,
    }).isRequired,
    buildAndQuoteUrl: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    configs: PropTypes.instanceOf(ConfigsModel).isRequired,
    hasAdobeTagging: PropTypes.bool.isRequired,
    displayCreditRate: PropTypes.bool,
    isCustomBodyStyle: PropTypes.bool,
    noMakeListStr: PropTypes.string,
    modelListStr: PropTypes.string,
};

function mapStateToProps(state) {
    return {
        catalogFilter: state.catalogFilter,
        manufacturer: state.manufacturer,
        purchaseMethods: state.purchaseMethods,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

Catalog.displayName = 'Catalog';

export { Catalog };
export default ConfigsContainer(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Catalog)
);
